import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const ExternalLinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`;

export const Divider = styled.div`
  width: 1px;
  height: 8px;
  background-color: ${colors.lightGray2};
  border-radius: 8px;
  align-self: center;
`;

export const ExternalLink = styled.a`
  color: ${colors.purple1};
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`;
